<template>
    <div class="card" :key="'m' + idx" style="padding: 0px;">
        <div class="card-header d-flex justify-content-between"
            :class="
                ( marcacao.ch_estado_marcacao == 'B' || marcacao.ch_estado_marcacao == 'C' ) ? 'alert-danger' : ( 
                marcacao.item_status.valor == 'agendado' ? 'alert-primary' : 
                        ( marcacao.item_status.valor == 'faltoso' ? 'alert-danger' : '' ) )"
            v-if="!noheader">
        <div>
            <div>
                <span v-if="side">
                    <i class="far fa-calendar-alt mr-2"></i>
                    {{ getHumanDate(marcacao.dt_inicio) }}, 
                    <span>{{ getHumanDay(marcacao.dt_inicio) }}, </span> 
                    <small>{{ getHumanDuration(marcacao.dt_inicio) }}</small>
                </span>
                <a class="card-link" data-toggle="collapse" :href="'#collapse-atd-' + idx" role="button" aria-expanded="false" aria-controls="collapseExample" v-else>
                    <i class="far fa-calendar-alt mr-2"></i>
                    {{ getHumanDate(marcacao.dt_inicio) }}, 
                    <span>{{ getHumanDay(marcacao.dt_inicio) }}, </span> 
                    <small>{{ getHumanDuration(marcacao.dt_inicio) }}</small>
                </a>

                <span class="ml-3 badge badge-danger" v-if="marcacao.ch_estado_marcacao == 'B'">
                    <i class="fa fa-ban mr-2" aria-hidden="true"></i>
                    Agenda Bloqueada
                </span>

                <span class="ml-3 badge badge-danger" v-else-if="marcacao.ch_estado_marcacao == 'C'">
                    <i class="fas fa-times-square mr-2" aria-hidden="true"></i>
                    Agenda Cancelada
                </span>
            </div>
            <div>
                <i class="far fa-clock mr-2"></i>
                <small>{{ marcacao.dt_inicio.substr(11,5) }}</small>
                <span class="badge badge-light ml-3" v-if="marcacao.unidade_operacao && marcacao.unidade_operacao.st_sigla">
                    {{ marcacao.unidade_operacao.st_sigla }} 
                </span>

                <span v-if="marcacao.fl_tele_atendimento" class="text-muted ml-3">
                    <i class="fas fa-satellite-dish"></i>
                </span>

                <span class="text-muted ml-3" v-if="marcacao.item_status.ultima_etapa && marcacao.item_status.ultima_etapa.id_etapa_atendimento == 7">
                    <span v-if="tem_arquivo(marcacao)">
                    <i class="fa fa-paperclip mr-2"></i>
                    </span>
                    <span v-if="tem_receita(marcacao)">
                        <a href="#" @click.prevent="selec_proc('rec')" class="card-link" :class=" id_proc_selec == 'rec' ? 'text-primary' : 'text-muted'" title="Receita/Prescrição">
                            <i class="fas fa-prescription mr-3"></i>
                        </a>
                    </span>
                    <span v-if="tem_requisicao(marcacao)">
                        <a href="#" @click.prevent="selec_proc('req')" class="card-link" :class=" id_proc_selec == 'req' ? 'text-primary' : 'text-muted'" title="Requisição">
                            <i class="fas fa-heartbeat mr-3"></i>
                        </a>
                    </span>
                    <span v-if="tem_docs(marcacao)">
                        <a href="#" @click.prevent="selec_proc('doc')" class="card-link" :class=" id_proc_selec == 'doc' ? 'text-primary' : 'text-muted'" title="Documentos/Relatórios">
                            <i class="fa-regular fa-file-lines mr-3"></i>
                        </a>
                    </span>
                    <span v-if="tem_atestado(marcacao)">
                    <i class="fa fa-plus mr-2"></i>
                    </span>
                </span>

                <!-- PACS -->
                <url-estudo-pacs v-if="pode_abrir_pacs(marcacao)"
                    :id_atendimento_procedimento="get_id_atendimento_procedimento(marcacao)"
                    :id_paciente="marcacao.id_paciente"
                    :sem_bordas="true">
                </url-estudo-pacs>
                <!-- <i class="fas fa-x-ray" 
                    style="cursor: pointer;"
                    data-toggle="tooltip" data-placement="top" title="Visualizar Imagens do PACS"
                    v-if="pode_abrir_pacs(marcacao)"
                    @click="open_url_estudo(marcacao)"
                ></i> -->
            </div>
        </div>
        <div class="d-flex">
            <div class="text-right">
                <div>
                    <span v-if="marcacao.st_regiao" class="badge badge-secondary mr-2">
                        {{ marcacao.st_regiao }}
                    </span>

                    <a href="#" @click.prevent="abrirAtendimentoNaRecepcao(marcacao)" v-if="na_recepcao && marcacao && marcacao.id_atendimento && marcacao.ch_estado_marcacao != 'C'" 
                    title="Visualizar Atendimento">
                        <i class="fas fa-play-circle"></i>
                    </a>

                    <a href="#" @click.prevent="retornarAoAtendimento(marcacao.atendimento)" class="card-link"
                        v-if="( !historico || no_consultorio ) && marcacao.atendimento && marcacao.medico 
                            && marcacao.medico.id_pessoa == $store.state.user.id_pessoa && marcacao.atendimento.pode_alterar_prontuario
                            && ( marcacao.item_status.valor != 'atendido' || !marcacao.item_status.na_recepcao )">
                        {{ marcacao.procedimento.search }}
                    </a>

                    <span v-else>
                        {{ marcacao.procedimento.search }}
                    </span>

                    <span v-if="marcacao.procedimento.id_classe_procedimento == 1 && marcacao.ch_tipo_consulta == 'R'" title="Revisão">
                      <i class="fas fa-registered text-danger ml-1" aria-hidden="true"></i>
                    </span>

                    <span v-if="marcacao.atendimento && marcacao.atendimento.fl_avulso" data-toggle="tooltip" data-placement="left" 
                        title="Registro Avulso. Sem registro de marcação/atendimento.">
                        <i class="fas fa-plus-circle ml-2 text-muted"></i>
                    </span>
                </div>
                <small>
                    <span class="text-muted mr-3" v-if="marcacao.plano">
                        {{ marcacao.plano.search }}
                    </span>

                    <span class="text-muted mr-3" v-if="marcacao.id_atendimento">
                        <a href="#" @click.prevent="abrirAtendimentoNaRecepcao(marcacao)" class="card-link"> 
                            #{{ marcacao.id_atendimento }}
                        </a>
                    </span>

                    {{ marcacao.medico.st_nome_exibicao }}
                </small>
            </div>
            <div v-if="!historico && $store.state.user.medico && marcacao.atendimento && marcacao.medico && marcacao.medico.id_pessoa == $store.state.user.id_pessoa && tem_doc_certificado(marcacao.atendimento)">
                <button type="button" class="btn btn-sm btn-outline-secondary ml-2" @click="compartilhar(marcacao.atendimento)">
                    <i class="fa fa-share" aria-hidden="true"></i>
                </button>
            </div>
        </div>
        </div>
        <div class="collapse collapse-pep" :class="expandido ? 'show' : ''" :id="'collapse-atd-' + idx">
        <div class="card-body">

            <div class="alert alert-danger" v-if="marcacao.ch_estado_marcacao == 'C'">
                <div class="small text-muted">{{ $util.getFormatDate(marcacao.dt_cancelamento) }}</div>
                <strong>Motivo Cancelamento:</strong> 
                {{ marcacao.st_motivo_cancelamento }}
                
                <template v-if="marcacao.st_observacoes">
                    <hr>
                    <span style="white-space: pre-wrap;">{{ marcacao.st_observacoes }}</span>
                </template>
            </div>

            <div class="small text-muted mb-3" v-if="marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos 
                && ( marcacao.atendimento.atendimento_procedimentos.length > 1 || marcacao.atendimento.atendimento_procedimentos.find(atp => atp.canc) )">
                <span v-for="(atp, iax) in agrupar_procedimentos(marcacao)" :key="iax">
                    <i class="fa fa-caret-right mx-2" aria-hidden="true" v-if="iax"></i>
                    <span class="badge badge-secondary" v-if="atp.qtd > 1">{{ atp.qtd }}</span>
                    <s v-if="atp.canc">{{ atp.proc }}</s>
                    <span v-else>
                        <a href="#" @click.prevent="selec_proc(atp)" class="card-link" :class="atp.id_procedimento == id_proc_selec ? 'font-weight-bold' : ''">{{ atp.proc }}</a>
                    </span>

                    <span v-if="atp.cor">
                        <i class="fa-solid fa-circle ml-1" :class="'text-' + atp.cor"></i>
                    </span>

                    <span class="badge badge-light" v-if="atp.senha">{{ atp.senha }}</span>

                    <!-- PACS -->
                     <url-estudo-pacs
                        v-if="atp.pacs"
                        :sem_bordas="true"
                        :id_atendimento_procedimento="atp.id"
                        :id_paciente="marcacao.id_paciente">
                    </url-estudo-pacs>
                    <!-- <i class="fas fa-x-ray mr-1 ml-1" 
                        style="cursor: pointer;"
                        v-if="atp.pacs"
                        data-toggle="tooltip" data-placement="top" title="Visualizar Imagens do PACS"
                        @click="open_url_estudo(atp, false)"
                    ></i> -->
                </span>                 
            </div>

            <!-- Pré Atendimento -->
            <pre-atendimento-view :marcacao="marcacao" />

            <!-- Paciente agendado -->
            <div v-if="marcacao.autorizacao && marcacao.autorizacao.status_solicitacao" class="d-flex flex-column">
                <a href="#" @click.prevent="abrir_solic_aut(marcacao.autorizacao)" class="badge mb-3" :class="'badge-' + marcacao.autorizacao.status_solicitacao.color">
                    Autorização: {{ marcacao.autorizacao.status_solicitacao.msg }}
                    <span class="ml-3">
                        <i class="fa-solid fa-stamp ml-1"></i>
                        {{ marcacao.autorizacao.id_solicitacao_autorizacao }}
                    </span>
                </a>
            </div>

            <span v-if="marcacao.item_status.valor == 'agendado'" class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <i class="far fa-calendar-alt fa-3x mr-3 text-primary" data-toggle="tooltip" data-placement="top" title="Atendimento Agendado"></i>
                    <template v-if="!historico">
                        <button type="button" class="btn btn-outline-primary mr-2" @click="$util.remarcar(marcacao)">
                            Remarcar
                        </button>
                        <button type="button" class="btn btn-outline-primary mr-2" @click="editar_marcacao(marcacao)">
                            Editar
                        </button>
                        <button type="button" class="btn btn-outline-danger mr-2" @click="cancelar_marcacao(marcacao)">
                            Cancelar
                        </button>
                        <button v-if="marcacao.dt_inicio.substr(0,10) == $util.hoje() && marcacao.id_medico == $store.state.user.id_pessoa && pode_atender"
                            type="button" class="btn btn-outline-success mr-2" @click="registrarAtendimento(marcacao)">
                            Atender
                        </button>
                    </template>
                    <h4>
                        <span class="ml-3 badge badge-danger" v-if="marcacao.ch_estado_marcacao == 'B'">
                            <i class="fa fa-ban mr-2" aria-hidden="true"></i>
                            Agenda Bloqueada
                        </span>
                    </h4>
                </div>
                <div v-if="marcacao.repeticao" class="text-right">
                    <div> 
                        <i class="fas fa-sync-alt mr-1"></i>
                        <span class="badge badge-secondary ml-1" v-for="(dia, idiax) in marcacao.dias" :key="idiax">
                            {{ dia }}
                        </span>
                    </div>
                    <div> 
                        <span class="badge badge-primary ml-1" v-for="(rec, irecx) in marcacao.recorrencias" :key="irecx">
                            {{ $util.getFormatDate(rec) }}
                        </span>
                    </div>
                </div>
            </span>

            <!-- Paciente Agendado, mas faltou -->
            <span v-else-if="marcacao.item_status.valor == 'bloqueado'" class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <i class="far fa-calendar-alt fa-3x mr-3 text-primary" data-toggle="tooltip" data-placement="top" title="Atendimento Agendado"></i>
                    <template v-if="!historico">
                        <button type="button" class="btn btn-outline-primary mr-2" @click="$util.remarcar(marcacao)">
                            Remarcar
                        </button>
                        <button type="button" class="btn btn-outline-danger mr-2" @click="cancelar_marcacao(marcacao)">
                            Cancelar
                        </button>
                    </template>
                </div>
            </span>

            <!-- Paciente Agendado, mas faltou -->
            <span v-else-if="marcacao.item_status.valor == 'faltoso'" class="d-flex align-items-center">
                <i class="far fa-calendar-times fa-3x mr-3 text-danger" data-toggle="tooltip" data-placement="top" title="Falta no Agendamento" ></i>
            <span>Falta no Agendamento</span>
            </span>

            <!-- Paciente chamado -->
            <span v-else-if="marcacao.item_status.ultima_etapa && marcacao.item_status.ultima_etapa.id_etapa_atendimento == 5">
                <button type="button" class="btn btn-success" @click="iniciarAtendimento(marcacao)" v-if="!historico">
                    <i class="fas fa-play mr-2" v-if="!$store.state.loading"></i>
                    <div class="spinner-border spinner-border-sm" role="status" v-else>
                    <span class="sr-only">Loading...</span>
                    </div>
                    Iniciar Atendimento
                </button>
            </span>

            <!-- Paciente chamado -->
            <span v-else-if="marcacao.item_status.ultima_etapa 
                && marcacao.item_status.ultima_etapa.id_etapa_atendimento == 6 
                && ( !marcacao.recepcao || !marcacao.recepcao.fl_emergencia )
                && ( !( marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos && marcacao.atendimento.atendimento_procedimentos[0] && marcacao.atendimento.atendimento_procedimentos[0].laudo ) )">
                <template v-if="marcacao.id_medico == $store.state.user.id_pessoa">
                    <template v-if="marcacao.dt_inicio.substr(0,10) < $util.hoje()">
                        <p class="alert alert-warning">Atendimento não finalizado.</p>
                        <button type="button" class="btn btn-danger" @click="retornarAoAtendimento(marcacao.atendimento)" v-if="!historico">
                            <i class="fas fa-play mr-2"></i>
                            Acessar Atendimento para Finalização
                        </button>
                    </template>
                    <button type="button" class="btn btn-success" @click="retornarAoAtendimento(marcacao.atendimento)" v-else-if="!historico">
                        <i class="fas fa-play mr-2"></i>
                        Retornar ao Atendimento
                    </button>
                </template>
                <template v-else>
                    <p class="alert alert-warning">Atendimento não finalizado.</p>
                </template>
            </span>

            <!-- Paciente atendido na recepção, aguardando ser chamado -->
            <span v-else-if="marcacao.item_status.valor == 'atendido'" class="d-flex align-items-center">

                <template v-if="marcacao.item_status.na_recepcao">
                    <i class="fas fa-user-friends fa-3x mr-3 text-warning"></i>
                    <button type="button" class="btn btn-outline-warning" @click="info_na_recepcao()">
                        Na Recepção
                    </button>
                </template>

                <template v-else>
                    <i class="far fa-bell fa-3x mr-3 text-success" data-toggle="tooltip" data-placement="top" title="Atendimento realizado na recepção"></i>
                    <button  type="button"  class="btn btn-outline-success mr-2" @click="chamar(marcacao)" v-if="!historico"
                        :disabled="$store.state.loading || marcacao.id_medico != $store.state.user.id_pessoa">
                        Chamar Paciente
                    </button>
                </template>
            </span>

            <!-- Paciente atendido. Registro do prontuário -->
            <span v-else-if="force_view || ( marcacao.item_status.ultima_etapa && ( marcacao.item_status.ultima_etapa.id_etapa_atendimento == 7 || ( marcacao.recepcao && marcacao.recepcao.fl_emergencia ) ) )">

                <div class="d-flex justify-content-between">
                    <div class="small border-bottom">
                        <span v-if="marcacao.atendimento && marcacao.atendimento.cid">CID: {{ marcacao.atendimento.cid.st_codigo }}</span>
                    </div>
                    <div>
                        <a href="#" @click.prevent="toggle_compress()" class="card-link">
                            <i class="fa-solid fa-minimize fa-fw" v-if="!compress_items"></i>
                            <i class="fa-solid fa-maximize fa-fw" v-else></i>  
                        </a>
                    </div>
                </div>

                <template v-for="(atdp, ida) in marcacao.atendimento.atendimento_procedimentos">

                    <div v-if="exibir_proc_selec(atdp)" :key="'a' + idx + '-' + ida">
                        <span v-if="atdp.anamnese">
                            <!-- Anamnese -->
                            <!-- && !( marcacao.atendimento.registros && marcacao.atendimento.registros.length ) -->
                            <div v-if="atdp.anamnese.st_anamnese
                                && ( !atdp.anamnese.dt_inclusao || atdp.anamnese.dt_inclusao != atdp.anamnese.dt_alteracao )" 
                                class="alert alert-light border-dark">

                                <div class="mb-3" v-if="atdp.anamnese.dados == '@'">
                                    <span v-html="atdp.anamnese.st_anamnese" />
                                </div>

                                <formulario 
                                    v-else
                                    ref="formulario"
                                    v-model="atdp.anamnese.dados" 
                                    :modelo_prontuario="atdp.anamnese.modelo_prontuario"
                                    mode="view" 
                                    :view_with_print="true" 
                                    :tamanho="tamanho" 
                                    :show_hide="true"
                                    :secundario="marcacao.id_procedimento != atdp.id_procedimento || ( marcacao.atendimento.registros && marcacao.atendimento.registros.length )" 
                                    @imprimirAnamnese="imprimirAnamnese(atdp.anamnese.id_anamnese)" />

                            </div>

                            <div v-if="marcacao.infusao" class="alert alert-info d-flex justify-content-between mt-3"> 
                                <div>
                                    {{ marcacao.infusao.st_titulo }} 
                                    <span class="badge badge-secondary ml-2" v-if="marcacao.in_qt_dia">D{{ marcacao.in_qt_dia }}</span>
                                </div>
                                <a href="#" @click.prevent="consultar_contatos('App\\azure\\receita', marcacao.infusao.protocolo.receita.id_receita)" v-if="marcacao.infusao && marcacao.infusao.protocolo && marcacao.infusao.protocolo.receita && marcacao.infusao.protocolo.receita.contato">
                                    <span class="badge" :class="'badge-' + marcacao.infusao.protocolo.receita.contato.contato_status.st_color">
                                        {{ marcacao.infusao.protocolo.receita.contato.contato_status.search }}
                                        / {{ $util.getFormatDate(marcacao.infusao.protocolo.receita.contato.created_at, 'DD/MM') }}
                                    </span>
                                </a>
                                <div v-if="marcacao.in_qt_ciclo && marcacao.infusao.ciclos">
                                    <i class="fa-solid fa-arrows-spin mr-2"></i>
                                    {{ marcacao.in_qt_ciclo }}/{{ marcacao.infusao.ciclos }}
                                </div>
                            </div>

                            <!-- Order Sets -->
                            <order-set-view :dados="atdp.anamnese.receita" :tamanho="tamanho" ref="receitas" type="receita" />
                            <order-set-view :dados="atdp.anamnese.requisicao" :tamanho="tamanho" ref="requisicoes" type="requisicao" />

                            <!-- Documentos -->
                            <div v-if="atdp.anamnese.documentos && atdp.anamnese.documentos.length">
                                <a href="#" class="text-white" @click.prevent="abrir_doc_view(doc)"
                                    v-for="(doc, iax) in atdp.anamnese.documentos" :key="iax" target="_blank">
                                    <span class="badge badge-warning p-2 mr-2 mb-2">
                                        <i class="far fa-file-alt mr-2"></i>
                                        {{ doc.st_titulo }}  
                                    </span>
                                </a>
                            </div> 
                            
                            <!-- Anexos -->
                            <div v-if="1==0 && atdp.anamnese.arquivos.length">
                                <a :href="arq.arquivo.temporary_url" class="text-white"
                                v-for="(arq, iax) in atdp.anamnese.arquivos" :key="iax" target="_blank">
                                <span class="badge badge-primary p-2 mr-2 mb-2">
                                    <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                    {{ arq.arquivo.st_titulo }}  
                                </span>
                                </a>
                            </div>

                            <!-- Anexos com Preview -->
                            <div class="alert alert-primary d-flex justify-content-between mt-3 mb-0" v-if="atdp.anamnese.arquivos.length">
                                <div>
                                    <a :href="arq.arquivo.temporary_url" class="text-white"
                                        v-for="(arq, iax) in atdp.anamnese.arquivos" :key="iax" target="_blank">
                                        <span class="badge badge-primary p-2 mr-2 my-1">
                                            <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                            {{ arq.arquivo.st_titulo }}  
                                        </span>
                                    </a>
                                </div>

                                <div>
                                    <a href="#" @click.prevent="toggle_ver_anexos_anamnese(atdp)">
                                        <i class="fa-solid fa-eye-slash fa-fw" v-if="!atdp.anamnese.ver_anexos"></i>
                                        <i class="fa-solid fa-eye fa-fw" v-else></i>
                                    </a>
                                </div>
                            </div>

                            <ver-arquivos-rolagem class="mt-3" v-if="atdp.anamnese.arquivos.length && atdp.anamnese.ver_anexos" :arquivos="atdp.anamnese.arquivos" />

                        </span>

                        <span v-else-if="marcacao.id_procedimento == atdp.id_procedimento">
                            Atendimento realizado
                        </span>

                    </div>

                </template>

            </span>
            <span v-else-if="marcacao.item_status.valor == 'concluido'" class="lead">
                <span v-if="!( marcacao.atendimento 
                    && marcacao.atendimento.atendimento_procedimentos 
                    && marcacao.atendimento.atendimento_procedimentos.find(item => item.laudo && item.laudo.id_status_laudo != 1 ) )">
                    Atendimento não finalizado.
                </span>
            </span>

            <span v-else>
                <pre v-if="1 == 0">{{ marcacao.item_status }}</pre>
            </span>


            <template v-if="marcacao.atendimento && marcacao.atendimento.amostras_klis_count">
                <div>
                    <span v-for="(atdp, iax) in marcacao.atendimento.atendimento_procedimentos.filter(atdp => atdp.laudo)" :key="iax" class="badge badge-pill badge-primary mr-1">
                        {{ atdp.procedimento.st_sigla ? atdp.procedimento.st_sigla : atdp.procedimento.st_procedimento }}
                    </span>
                </div>

                <div>
                    <button type="button" class="btn btn-outline-primary btn-sm d-print-none mt-3" @click="verificar_resultado_klis(marcacao)" :disabled="$store.state.loading">
                        <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="$store.state.loading"></span>
                        <i class="fa fa-search mr-2" aria-hidden="true" v-else></i>
                        Verificar Resultados
                    </button>

                    <div class="mt-3" v-if="marcacao.laudo_klis && marcacao.laudo_klis.resultados && marcacao.laudo_klis.resultados.html">
                        <span v-html="marcacao.laudo_klis.resultados.html"></span>
                    </div>
                </div>
            </template>

            <template v-if="marcacao.atendimento">
                <template v-for="(atdp, ida) in marcacao.atendimento.atendimento_procedimentos">
                    <div :key="'a' + idx + '-' + ida" v-if="exibir_proc_selec(atdp) && atdp.laudo && atdp.laudo.status_laudo && ( atdp.laudo.status_laudo.fl_pronto || atdp.laudo.arquivos.length || cancelado )">
                        <div class="alert d-flex justify-content-between mt-3" :class="atdp.fl_ativo ? 'alert-info' : 'alert-danger'">
                            <span>{{ atdp.procedimento.search }}</span>
                            <div>
                                <span class="badge badge-danger" v-if="!atdp.fl_ativo">Atendimento Cancelado</span>
                                <span v-if="atdp.laudo && atdp.laudo.doc_certificado">
                                    <a :href="atdp.laudo.doc_certificado.arquivo.temporary_url" target="_blank" class="ml-2">
                                        <i class="fa-solid fa-file-contract"></i>
                                    </a>
                                </span>
                            </div>
                        </div>

                        <template v-if="atdp.laudo && atdp.laudo.arquivos && atdp.laudo.arquivos.length">
                            <visualizar-laudo-externo :atp="atdp" />
                        </template>

                        <template v-if="( atdp.laudo.status_laudo.fl_pronto || cancelado )">

                            <span v-if="!( atdp.laudo && atdp.laudo.arquivos && atdp.laudo.arquivos.filter(arq => arq.st_tipo_especial != 'anexo').length )">

                                <template v-if="atdp.laudo.partes && atdp.laudo.partes.length">
                                    <div v-for="(registro, iregx) in atdp.laudo.partes" :key="iregx">
                                        <campos-formulario 
                                            v-model="registro.st_conteudo" 
                                            :raiz="true" 
                                            mode="view"
                                            :compact="false" />
                                    </div>
                                </template>

                                <template v-else>
                                    <formulario 
                                        v-model="atdp.laudo.dados" 
                                        mode="view" 
                                        :view_with_print="true" 
                                        :secundario="marcacao.id_procedimento != atdp.id_procedimento || ( marcacao.atendimento.registros && marcacao.atendimento.registros.length )" 
                                        :modelo_prontuario="atdp.laudo.modelo_prontuario"
                                        @imprimirAnamnese="imprimir_laudo(atdp.laudo.id_laudo)" />
                                </template>
                            </span>

                            <!-- Arquivos do Laudo -->

                            <template v-if="atdp.laudo && atdp.laudo.arquivos && atdp.laudo.arquivos.length">

                                <div class="alert alert-primary d-flex justify-content-between mt-3" v-if="atdp.laudo.arquivos && atdp.laudo.arquivos.length">
                                    <div>
                                        {{ atdp.laudo.arquivos.length }} arquivo(s)
                                    </div>

                                    <div>
                                        <a href="#" @click.prevent="toggle_ver_anexos_laudo(atdp)">
                                        <i class="fa-solid fa-eye-slash fa-fw" v-if="!atdp.laudo.ver_anexos"></i>
                                        <i class="fa-solid fa-eye fa-fw" v-else></i>
                                        </a>
                                    </div>
                                </div>

                                <ver-arquivos-rolagem :arquivos="atdp.laudo.arquivos" v-if="atdp.laudo.ver_anexos" />

                            </template>

                        </template>

                        <template v-else-if="atdp.laudo.status_laudo">
                            <span class="badge h5" :class="'badge-' + atdp.laudo.status_laudo.st_color">
                                {{ atdp.laudo.status_laudo.search }}
                            </span>
                        </template>
                    </div>
                </template>

                <!-- Seleção de Receitas e Requisições -->
                <template v-if="id_proc_selec && lista_docs && lista_docs.length">
                    <template v-if="id_proc_selec == 'doc'">
                        <a href="#" class="text-white" @click.prevent="abrir_doc_view(doc)"
                            v-for="(doc, iax) in lista_docs" :key="iax" target="_blank">
                            <span class="badge badge-warning p-2 mr-2 mb-2">
                                <i class="far fa-file-alt mr-2"></i>
                                {{ doc.st_titulo }}  
                            </span>
                        </a>
                    </template>

                    <template v-else>
                        <order-set-view :dados="lista_docs" :tamanho="tamanho" ref="receitas" type="receita" />
                    </template>
                </template>

                <!-- Registros da Assistência -->
                <template v-if="!id_proc_selec && marcacao.atendimento.registros && marcacao.atendimento.registros.length">

                    <div v-for="(registro, iregx) in marcacao.atendimento.registros" :key="iregx">
                        <div v-if="registro.st_conteudo && registro.st_conteudo.length">
                            <az-sub-title :title="registro.modelo ? registro.modelo.st_modelo_prontuario : ''" :info_sm="true" :showhide="true" :model="registro">
                                {{ titulo_registro(registro) }}
                            </az-sub-title>

                            <campos-formulario 
                                v-if="!registro.hide"
                                v-model="registro.st_conteudo" 
                                :raiz="true" 
                                mode="view"
                                :modelo="registro.modelo"
                                :compact="registro.modelo.fl_compact" />
                        </div>
                    </div>

                </template>

            </template>

            <div v-if="marcacao.arquivos.length">
                <az-sub-title class="mt-3" title="Anexos do Atendimento" />
                <a :href="arq.arquivo.temporary_url" class="text-white"
                    v-for="(arq, iax) in marcacao.arquivos" :key="iax" target="_blank">
                    <span class="badge badge-primary p-2 mr-2 mb-2">
                    <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                    {{ arq.arquivo.st_titulo }}  
                    </span>
                </a>
            </div>

            <div v-if="marcacao.doc_receps && marcacao.doc_receps.length">
                <az-sub-title class="mt-3" title="Documentos Recepção" />
                <a href="#" @click.prevent="abrir_doc_view(docr)" class="text-white" v-for="(docr, iax) in marcacao.doc_receps" :key="iax">
                    <span class="badge badge-info p-2 mr-2 mb-2">
                        <i class="far fa-file-alt mr-2"></i>
                        {{ docr.st_titulo }}  
                    </span>
                </a>
            </div>

        </div>

        </div>
    </div>
</template>

<script>
import * as moment from "moment";
import _ from 'lodash';
import $ from 'jquery';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Formulario from "./Formulario.vue";
import CamposFormulario from "./CamposFormulario.vue";
import OrderSetView from "./OrderSetView.vue";
import PreAtendimentoView from "./PreAtendimentoView.vue";
import VisualizarLaudoExterno from "./VisualizarLaudoExterno.vue";
import VerArquivosRolagem from "./VerArquivosRolagem.vue";
import UrlEstudoPacs from "../pacs/UrlEstudoPacs.vue";

export default {
    data() { 
        return { 
            expandido: true, 
            compress_items: false, 
            id_proc_selec: null, 
        };
    },

    props: ['marcacao', 'idx', 'tamanho', 'pode_atender', 'side', 'cancelado', 'historico', 'force_view', 'noheader'],

    components: { 
        AzSubTitle,
        Formulario,
        CamposFormulario, 
        OrderSetView, 
        PreAtendimentoView,
        VisualizarLaudoExterno, 
        VerArquivosRolagem,
        UrlEstudoPacs
    },

    computed: { 
        na_recepcao: function() { 
            return this.$route.path == '/recepcao';
        },

        no_consultorio: function() { 
            return this.$route.path.substr(0,16) == '/consultorio/res';
        },

        lista_docs: function() { 

            if ( !this.marcacao || !this.marcacao.atendimento || !this.marcacao.atendimento.atendimento_procedimentos || !this.marcacao.atendimento.atendimento_procedimentos.length ) { 
                return [];
            }

            if ( this.id_proc_selec == 'rec' ) { 
                return this.marcacao.atendimento.atendimento_procedimentos
                    .filter(item => item.anamnese && item.anamnese.receita && item.anamnese.receita.length)
                    .map(item => item.anamnese.receita)
                    .flat();
            } else if ( this.id_proc_selec == 'req' ) { 
                return this.marcacao.atendimento.atendimento_procedimentos
                    .filter(item => item.anamnese && item.anamnese.requisicao && item.anamnese.requisicao.length)
                    .map(item => item.anamnese.requisicao)
                    .flat();
            } else if ( this.id_proc_selec == 'doc' ) { 
                return this.marcacao.atendimento.atendimento_procedimentos
                    .filter(item => item.anamnese && item.anamnese.documentos && item.anamnese.documentos.length)
                    .map(item => item.anamnese.documentos)
                    .flat();
            }

            return [];

        },
    },

    methods: { 
        exibir_proc_selec (atp, orderset = null) { 
            if ( !this.id_proc_selec ) { 
                return true; 
            }

            if ( ( this.id_proc_selec == 'rec' ) && orderset && orderset.id_receita ) { 
                return true; 
            }

            if ( ( this.id_proc_selec == 'req' ) && orderset && orderset.id_requisicao ) { 
                return true; 
            }

            if ( atp && ( this.id_proc_selec == atp.id_procedimento ) ) {
                return true; 
            }

            return false; 
        },

        selec_proc(atp) { 
            if ( atp && atp.id_procedimento ) { 
                atp = atp.id_procedimento; 
            } 

            if ( typeof atp != 'number' && typeof atp != 'string' ) { 
                return;
            }

            if ( this.id_proc_selec == atp ) { 
                this.id_proc_selec = null;
                return;
            }

            this.id_proc_selec = atp;
        },

        abrir_solic_aut (autorizacao) { 
            if ( !autorizacao ) { 
                return;
            }

            $('.modal').modal('hide');

            if ( this.$router.currentRoute.name == 'solic-autoriz' ) {
                
                this.$router.push({ name: "dashboard" });

                this.$nextTick(() => {
                    this.$router.push({ 
                        name: 'solic-autoriz',
                        params: { 
                            aba: 'lista', 
                            id: autorizacao.id_solicitacao_autorizacao,
                        },
                    });
                });
                
            } else { 
      
                this.$router.push({ 
                    name: 'solic-autoriz',
                    params: { 
                        aba: 'lista', 
                        id: autorizacao.id_solicitacao_autorizacao,
                    },
                });

            }
        },

        verificar_resultado_klis (marcacao) { 
            this.$util.load(this, { 
                service: 'laudos',
                func: 'resultados_klis', 
                parms: { 
                    id_atendimento: marcacao.id_atendimento, 
                },
                loadTo: res => { 
                    marcacao.laudo_klis = res;
                    this.$forceUpdate();
                }
            });
        },

        toggle_ver_anexos_laudo (item) { 
            item.laudo.ver_anexos = !item.laudo.ver_anexos;

            this.$forceUpdate();
        },

        toggle_ver_anexos_anamnese (item) { 
            item.anamnese.ver_anexos = !item.anamnese.ver_anexos;
            this.$forceUpdate();
        },

        consultar_contatos (model_type, model_id) { 
            this.$parent.consultar_contatos(model_type, model_id);
        },

        toggle_compress () { 
            this.compress_items = !this.compress_items;

            if ( this.marcacao && this.marcacao.atendimento && this.marcacao.atendimento.registros ) { 
                this.marcacao.atendimento.registros.forEach(registro => { 
                    registro.hide = this.compress_items;
                });
            }

            // console.log('forms', this.$refs.formulario);
            
            if ( this.$refs.formulario ) { 
                this.$refs.formulario.forEach(form => { 
                    form.comprimido = this.compress_items 
                });
            }

            if ( this.$refs.receitas ) { 
                this.$refs.receitas.forEach(item => { 
                    item.toggle_hide_order_all(this.compress_items); 
                });
            }

            if ( this.$refs.requisicoes ) { 
                this.$refs.requisicoes.forEach(item => { 
                    item.toggle_hide_order_all(this.compress_items); 
                });
            }
            
        },

        pode_abrir_pacs(marcacao) { 
            return marcacao
                && marcacao.atendimento
                && marcacao.atendimento.atendimento_procedimentos 
                && marcacao.atendimento.atendimento_procedimentos.length == 1
                && marcacao.atendimento.atendimento_procedimentos[0].st_pacs == "OK";
        },

        get_id_atendimento_procedimento(marcacao) { 
            return marcacao.atendimento.atendimento_procedimentos[0].id_atendimento_procedimento;
        },

        // open_url_estudo(item, isMarcacao = true) {
        //     const id_atendimento_procedimento = isMarcacao ? this.get_id_atendimento_procedimento(item) : item.id;
            
        //     this.$util.load(this, {
        //         service: 'pep',
        //         func: 'dr_tis_url',
        //         parms: {
        //             id_atendimento_procedimento: id_atendimento_procedimento,
        //             id_paciente: this.marcacao.id_paciente,
        //         },
        //         loadTo: (res) => {
        //             if(res && res.url) {
        //                 window.open(res.url, '_blank').focus();
        //             }
        //         }
        //     });

        // },

        info_na_recepcao () { 
            this.$toast.add({
                severity: 'warn',
                summary: "Chamar",
                detail: "Paciente em atendimento na recepção.",
                life: 3000
            });
        },
            
        titulo_registro(registro) { 
            if ( registro && registro.fl_consultorio ) { 
                return _.get(registro, 'modelo.st_modelo_prontuario', 'Notas');
            }

            return _.get(registro, 'usuario.pessoa.st_nome') + ', ' + 
                ( !registro.created_at ? 'Novo' : registro.created_at.substr(11,5) );
        },

        agrupar_procedimentos(marcacao) { 
            let lista = _.map(
                    _.groupBy(marcacao.atendimento.atendimento_procedimentos, 'id_procedimento'),
                    (itens) => { 
                        return { 
                            canc: !_.find(itens, item => item.fl_ativo), 
                            qtd: _.sumBy(itens, 'in_quantidade'),
                            proc: _.first(itens).procedimento.search, 
                            id_procedimento: _.first(itens).id_procedimento,
                            senha: _.uniq(
                                    itens.filter(item => item.st_codigo_autorizacao).map(item => item.st_codigo_autorizacao)
                                ).join(', '),
                            pacs: _.first(itens).st_pacs == 'OK',
                            id: _.first(itens).id_atendimento_procedimento,
                            cor: ( _.get(itens, '0.procedimento.id_especialidade') != 2 ?  _.get(itens, '0.laudo.status_laudo.st_color') : '' ),
                        };
                    }
                );

            lista = _.orderBy(lista, 'proc');

            return lista;
        },
        imprimirAnamnese(id_anamnese) {
          this.$util.print_preview('imprimir/anamnese/' + id_anamnese, true);
        },

        imprimir_laudo(laudo) { 
          this.$util.print_preview('imprimir/laudo/' + laudo, true);
        },

        abrir_doc_view(doc) { 
            this.$emit('abrir_doc_view', doc);
        },
        iniciarAtendimento(marcacao) { 
            this.$emit('iniciarAtendimento', marcacao);
        },
        chamar (marcacao) { 
            this.$emit('chamar', marcacao);
        },
        registrarAtendimento(marcacao) { 
            this.$emit('registrarAtendimento', marcacao);
        },
        cancelar_marcacao(marcacao) { 
            this.$emit('cancelar_marcacao', marcacao);
        },
        editar_marcacao(marcacao) { 
          this.$root.editar_marcacao(marcacao.id_marcacao);
        },
        abrirAtendimentoNaRecepcao(marcacao) { 
            // close modal
            $('.modal').modal('hide');
            this.$util.abrir_atendimento(this, marcacao.id_atendimento);
            // this.$emit('abrirAtendimentoNaRecepcao', marcacao);
        },
        retornarAoAtendimento(atendimento) { 
            this.$emit('retornarAoAtendimento', atendimento);
        },
        compartilhar(atendimento) { 
            this.$emit('compartilhar', atendimento);
        },

        tem_receita (marcacao) { 
            return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.receita && item.anamnese.receita.length) ? true : false;
        },

        tem_requisicao (marcacao) { 
            return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.requisicao && item.anamnese.requisicao.length) ? true : false;
        },

        tem_docs (marcacao) { 
            return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.documentos && item.anamnese.documentos.length) ? true : false;
        },

        tem_arquivo (marcacao) { 
            return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.arquivos && item.anamnese.arquivos.length) ? true : false;
        },

        tem_atestado (marcacao) { 
            return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.atestados && item.anamnese.atestados.length) ? true : false;
        },

        tem_doc_certificado(atendimento) {

            if ( !atendimento )
                return false;

            if ( atendimento.atendimento_procedimentos.findIndex(atp => {

                if ( atp.anamnese ) { 

                if ( atp.anamnese.receita.findIndex(item => {
                    return !!item.doc_certificado;
                }) >= 0 ) { 
                    return true;
                } 

                if ( atp.anamnese.requisicao.findIndex(item => {
                    return !!item.doc_certificado;
                }) >= 0 ) { 
                    return true;
                } 

                }

                return false;
                
            }) >= 0 ) { 
                return true;
            }

            return false;

        },

        getHumanDay(date) {
            return moment(date, "YYYY-MM-DD").format("dddd");
        },

        getHumanDate(date) {
            return (
                moment(date, "YYYY-MM-DD").format("DD") +
                " de " +
                moment(date, "YYYY-MM-DD").format("MMMM") +
                (moment(date, "YYYY-MM-DD").format("YYYY") == new Date().getFullYear()
                ? ""
                : " de " + moment(date, "YYYY-MM-DD").format("YYYY"))
            );
        },
        getHumanDuration(date) {
            if (date.substr(0, 10) == this.$util.hoje()) 
                return "hoje";
            else
                return moment.duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje())).humanize(true);
        },
    }
}
</script>
